import React from "react";
import PropTypes from "prop-types";
import fordStyles from "./SortingIcon-Ford.module.scss";
import lincolnStyles from "./SortingIcon-Lincoln.module.scss";

const SortingIcon = (props) => {
  if (props.hide) return null;

  const prevSortKey = props.currentKey;
  const styles =
    props.isFordBrand || !Object.hasOwn(props, "isFordBrand")
      ? fordStyles
      : lincolnStyles;

  const index = props.index ?? "";

  let displaySortIcon = (
    <span
      className={styles.sortDown}
      data-testid={"downIcon" + prevSortKey + index}
    />
  );

  if (props.sortKey === prevSortKey) {
    displaySortIcon =
      props.sortDirection === "ASC" ? (
        <span
          className={styles.sortUpFilled}
          data-testid={"upIconFilled" + prevSortKey + index}
        />
      ) : (
        <span
          className={styles.sortDownFilled}
          data-testid={"downIconFilled" + prevSortKey + index}
        />
      );
  }

  return displaySortIcon;
};

SortingIcon.propTypes = {
  currentKey: PropTypes.string,
  hide: PropTypes.bool,
  index: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isFordBrand: PropTypes.bool,
  sortDirection: PropTypes.string,
  sortKey: PropTypes.string,
};

export default SortingIcon;
